import Topbar from '../src/components/topbar/topbar';
import Intro from '../src/components/intro/intro';
import Contact from '../src/components/contact/contact';
// import Menu from "../src/components/menu/menu";
import Portfolio from "../src/components/portfolio/portfolio";
// import PortfolioList from '../src/components/portfolioList/portfolioList';
import { useState } from 'react';

import Testimonials from "../src/components/testimonials/testimonials";
import Works from "../src/components/works/works";
import "./app.scss";
import Menu from './components/menu/menu';
import Skills from './components/skills/skills';

function App() {
  const [menuOpen, setMenuOpen] = useState(false)

  return (
    <div className="app">
      <Topbar menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
      <Menu menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
      <div className="sections">
        <Intro />
        <Skills />
        <Portfolio />
        <Works />
        <Testimonials />
        <Contact />
      </div>
    </div>
  );
}

export default App;
